import { useTranslation } from "react-i18next";

/**
 * Game codes are Latin/numeric even in Arabic, so the value is pinned LTR
 * while the surrounding label follows the page direction.
 */
export default function GameCodeChip({ code }: { code: string }) {
  const { t } = useTranslation();
  if (!code) return null;

  return (
    <span className="chip-code">
      <i className="pi pi-hashtag" aria-hidden="true" style={{ fontSize: ".72rem" }} />
      {t("common.gameCode").replace(/[:：]\s*$/, "")}
      <span className="chip-code__value">{code}</span>
    </span>
  );
}
